export default __webpack_public_path__ + "static/media/layoutPasscode.cf9dad01.png";